import { IconLineClose } from "@kalodata/kds-design-icons";
import { Modal, type ModalProps } from "antd";

export interface ClipModalProps extends ModalProps {}

export const ClipModal = (props: ClipModalProps) => {
  const { open, children, ...restProps } = props;
  return (
    <Modal
      destroyOnHidden
      open={open}
      footer={null}
      closeIcon={<IconLineClose size={20} />}
      mask={{ closable: true }}
      {...restProps}
      classNames={{
        container: "p-[16px]! flex flex-col gap-y-[4px]",
        title: "text-[16px] font-semibold leading-[24px] text-kds-fg",
        header: "mb-[0px]!",
        body: "p-0! flex-1 min-h-0",
        ...restProps.classNames,
      }}
    >
      {children}
    </Modal>
  );
};
